import { makeStyles } from '@material-ui/styles'

const navMarginFromTop = 12
const navHeight = 24
const ticketMarginFromTop = 80
const ticketTopMargin = ticketMarginFromTop - navHeight - navMarginFromTop
const artistImgMarginFromTop = 80 + ticketMarginFromTop

export const useStyles = makeStyles(theme => ({
    container: {
        textAlign: 'center',
        padding: `${navMarginFromTop}px 12px 0 12px`,
        backgroundColor: theme.colors.black,
        '& p': {
            marginBottom: '0',
        },
        '@media (min-width: 768px)': {
            width: '768px',
        },
    },
    navLogo: {
        height: `${navHeight}px`,
        width: `${navHeight}px`,
        textAlign: 'left',
        display: 'block',
    },
    ticket: {
        marginTop: `${ticketTopMargin}px`,
    },
    artistImg: {
        height: '100px',
        width: '100px',
        borderRadius: '8px',
        objectFit: 'cover',
    },
    ticketTitle: {
        ...theme.typographyPresets.titleSmallBold,
        ...theme.fontColors.light,
        fontSize: '20px',
        marginTop: '20px',
        lineHeight: '1',
    },
    ticketQuantity: {
        ...theme.typographyPresets.titleSmall,
        ...theme.fontColors.light,
        lineHeight: 'normal',
        marginTop: '12px',
    },
    overlayContents: {
        position: 'absolute',
        top: `${artistImgMarginFromTop}px`,
        left: '0',
        right: '0',
        margin: '0 auto',
        width: '240px',
        padding: '0 12px',
    },
}))
